/**
 * Standalone entry point (`npm run start:standalone`).
 *
 * The dynamic import is required, not stylistic: Module Federation initializes
 * its shared modules asynchronously, so an entry that reaches them synchronously
 * runs before the share scope exists and silently renders nothing. Deferring
 * behind `import()` gives webpack the async boundary it needs.
 *
 * In the Control Panel host this file never runs — `frame.js` pulls `./BcApp`
 * and drives mount/render itself.
 */
export {};

void import("./standalone");
